import { ImageBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpImageBlock } from './AmpImageBlock';
import { ImageBlock } from './ImageBlock';

export const ImageBlockMapping: BlockMapping<ImageBlockData> = {
  invariant: [
    {
      prop: 'image',
      msg: 'Image data required for image',
    },
    {
      prop: 'width',
      msg: 'width required for image',
    },
  ],
  width: ({ width }: { width: 'WIDE' | 'NARROW' }) =>
    width === 'WIDE' ? 'GRID' : 'NARROW',
  Component: ImageBlock,
  AmpComponent: AmpImageBlock,
};
